import { render } from "./Role.vue?vue&type=template&id=e405ed3e&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"

import "./Role.vue?vue&type=style&index=0&id=e405ed3e&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e405ed3e"]])

export default __exports__